import { getWillShowNav4 } from './get-will-show-nav4/index.tsx';

// The opposite of `getWillShowNav4`.
export const getWillShowNav3 = () => !getWillShowNav4();
